export enum ValidationResultCode {
  InactiveContact = "InactiveContact",
  ContactNotAVendor = "ContactNotAVendor",
  PlacementAttributeCombination = "PlacementAttributeCombination",
  SameCarerSameClientOverlappingPlacement = "SameCarerSameClientOverlappingPlacement",
  SameClientDifferentCarerOverlappingPlacement = "SameClientDifferentCarerOverlappingPlacement",
  NoClient = "NoClient",
  NoCarer = "NoCarer",
}
